import { Box, Typography } from '@mui/material'
import React from 'react'
import { fullCenter, pastelOrange, textColor } from '../Pages/Main/constants';
import { Motion } from '../Components/Motion';
import { useFirestore } from '../Firebase/FirestoreProvider';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import { signOut } from 'firebase/auth';
import { useDialog } from './DialogManager';
import { auth } from '../Firebase/firebase_init';
import { Link, useLocation } from 'react-router-dom';

export const ADMIN_HEIGHT = 80;

export default function AdminPanel() {
    const { saveData } = useFirestore();
    const { setDialog } = useDialog();
    const location = useLocation();
    const prehled = Boolean(location.pathname === "/preview");

    return (
        <Box sx={{ width: '100%', height: `${ADMIN_HEIGHT}px`, bgcolor: 'white', position: 'fixed', top: 0, zIndex: 20, ...fullCenter }}>

            <Motion scale={1.02}>
                <Box sx={{ border: `1px solid ${textColor}`, borderRadius: '24px', ml: '32px', height: '36px', ...fullCenter }}>
                    <Typography component={Link} to={prehled ? '/' : '/preview'}
                        sx={{ mr: 'auto', fontFamily: 'inter', fontSize: '17px', fontWeight: 600, py: '12px', px: '18px', cursor: 'pointer', textDecoration: 'none', color: textColor }}>
                        {prehled ? `Web` : `Přehled`}
                    </Typography>
                </Box>
            </Motion>
            <Box sx={{ ml: 'auto', mr: '32px', display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center' }}>

                <Motion style={{ marginRight: '32px' }}>
                    <Box sx={{ p: '5px', height: '42px', cursor: 'pointer' }} onClick={() => {
                        signOut(auth).then((result) => {

                        }).catch((err) => {
                            setDialog("Odhlášení se nezdařilo");
                        });
                    }}>
                        <ExitToAppRoundedIcon sx={{ width: '32px', height: '32px', color: pastelOrange }} />
                    </Box>
                </Motion>

                <Motion scale={1.01} style={{}}>
                    <Box sx={{
                        height: "48px",
                        minWidth: "180px",
                        width: 'fit-content',
                        borderRadius: "35px", bgcolor: pastelOrange,
                        textAlign: "center",
                        mb: "0px",
                        cursor: 'pointer',
                        ...fullCenter,
                    }}
                        onClick={() => { saveData() }}
                    >
                        <Typography
                            variant="buttonText"
                            sx={{ color: 'white', fontWeight: 'bold' }}
                        >
                            Uložit
                        </Typography>
                    </Box>
                </Motion>
            </Box>
            <Box sx={{ bgcolor: '#ccc', bottom: 0, width: '100%', height: '1px', position: 'absolute' }} />
        </Box >
    )
}
